
































































import Vue from 'vue'
import { Checkbox } from 'element-ui'

/**
 * DdCheckbox extending ElCheckbox with custom size
 */

export default Vue.extend({
  name: 'DdCheckbox',

  extends: Checkbox,

  props: {
    /**
     * Checkbox size: normal(12), medium(16) or large(18)
     */
    ddSize: {
      type: String,
      default: 'normal',
    },
  },

  computed: {
    checkboxSizeClass(): String {
      let size = 'normal'

      switch (this.ddSize) {
        case 'medium':
          size = 'medium'
          break
        case 'large':
          size = 'large'
          break
        default:
          size
      }
      return size
    },
  },
})
